export default "__VITE_ASSET__0dd85d86__"